"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collapse = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
require("./index.scss");
const Collapse = (props) => {
    const { collapsed, enabled, children } = props;
    const [expanded, setExpanded] = (0, react_1.useState)(!collapsed);
    const toggleExpanded = () => setExpanded(_expanded => !_expanded);
    const className = (0, classnames_1.default)('collapse', enabled && !expanded ? 'collapse--collapsed' : undefined);
    const contentStyle = enabled ? { height: expanded ? 'auto' : 400 } : undefined;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: 'collapse__content', style: contentStyle }, children),
        enabled && (react_1.default.createElement("button", { className: 'collapse__button', onClick: toggleExpanded }, expanded ? (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Collapse:showLess', defaultMessage: 'Show less' })) : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Collapse:showMore', defaultMessage: 'Show more' }))))));
};
exports.Collapse = Collapse;
//# sourceMappingURL=index.js.map